module.exports = __webpack_public_path__ + "img/bul_transform.91d605e1.svg";